// extracted by mini-css-extract-plugin
export var alignCenter = "_75-d";
export var bannerShown = "_75-6";
export var buttonContent = "_75-0";
export var cardList = "_75-1";
export var centerContent = "_75-2";
export var chevron = "_75-3";
export var closePanelButton = "_75-k";
export var conversationContextContainer = "_75-l";
export var conversationDetailContainer = "_75-4";
export var detailWrapper = "_75-7";
export var dropdownButton = "_75-e";
export var dropdownTitle = "_75-9";
export var fullHeight = "_75-5";
export var hidden = "_75-a";
export var icon = "_75-b";
export var mergeSuggestionWrapper = "_75-m";
export var panel = "_75-i";
export var portalButtonsWrapper = "_75-c";
export var right = "_75-j";
export var tableSummaryContainer = "_75-8";
export var tableSummaryHeader = "_75-g";
export var threeDotsButton = "_75-f";
export var wide = "_75-h";